

function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);

    if (source && destination) destination.innerHTML = source.innerHTML;
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;      
      cartRemove.addEventListener('click',(evt) => removeItem(data_line));
    });

    // document.querySelectorAll('.header__icon--cart').forEach(function(cartButton){
    //   cartButton.addEventListener('click',function(e){
    //     window.scrollTo(0, 0);
    //     if(!document.querySelector('body').classList.contains("template-cart")){
    //       document.querySelector('body').classList.add('open-drawer');
    //       document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');  
    //     }
    //   });
    // });
    // document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
    //   cartButton.addEventListener('click',function(e){
    //     document.querySelector('body').classList.remove('open-drawer','open-menu','open-search','open-sort','open-filter');
    //   });
    // });
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      var cart_total = data.total_price;

      document.querySelectorAll('.cart-count-bubble').forEach(function(e){
        e.classList.remove("hidden");
        e.innerHTML = cart_count;
      });
      
      if(cart_count > 0){
        
        var countDivDesktop = document.querySelector('.cart-item-count');

        var countDivCart = document.querySelector('.cartdrawer-item-count');
    
        if(countDivDesktop != undefined){
          if(cart_count > 1){
            countDivDesktop.innerHTML = '('+cart_count + ' items)';
          }else{
            countDivDesktop.innerHTML = '('+cart_count + ' item)';
          }  
        }

        if(countDivCart != undefined){
          if(cart_count > 1){
            countDivCart.innerHTML = cart_count + ' items';
          }else{
            countDivCart.innerHTML = cart_count + ' item';
          }  
        }
        
      }else{
        
        var countDiv = document.querySelector('.cart-count-bubble');
        var countDivDesktop = document.querySelector('.cart-item-count');
        
        if(countDiv != undefined){
          countDiv.innerHTML = 0;
          countDiv.classList.add("hidden");
        }
        if(countDivDesktop != undefined){
          countDivDesktop.innerHTML = 0 + ' item';
        }
        
      }
      setTimeout(function(){ 
        featured_slider();
      }, 500);  

    })
    .catch(function(error) {
      console.log(error);
    })
  });

  
}

load_cart();

function removeItem(data_line){
  const data = {'line': data_line ,'quantity': 0 };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    load_cart();
    setTimeout(function(){ featured_slider(); }, 500);
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function updateQuantity(data_index, data_qty,itemrow) {
  
  var upId = data_index;
  var upQTY = data_qty;
  var OldQty = Number(data_qty);

  if(itemrow.getAttribute('data-min-qty') != null){
    var minQty = Number(itemrow.getAttribute('data-min-qty'));
  }
  
  if(itemrow.closest('.item-row') != null){
    var itemTag = itemrow.closest('.item-row').getAttribute('data-item--tag');
    if(itemTag == 'CP' && (OldQty < 50 && OldQty >= 1)){
      upQTY = 50;
    }else if(itemTag == 'B2B' && (OldQty < minQty && OldQty >= 1)){
      upQTY = minQty;
    } else{
      if(itemTag == 'B2B' || itemTag == 'CP'){
      
        var oldInputVal = itemrow.getAttribute('data-old-value');
        var interVal = itemrow.getAttribute('data-plus-step');
        
        var mod = Number(upQTY % interVal);
        if(mod == 0){
          upQTY = data_qty;
        }else{
          upQTY = oldInputVal;
        }  
      }
    }
  }
  
  updateCartItem(upId, upQTY)	
  
  async function updateCartItem(id, qty) {
    const result = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: id,
        quantity: qty
      })
    })
    .then((data) => {
      if(data.status === 200){
        load_cart();
        
        setTimeout(function(){ 
          if(itemrow.closest('.item-row') != null){
            var itemTag = itemrow.closest('.item-row').getAttribute('data-item--tag');
            var errorId = itemrow.getAttribute('data-errorID');
            //console.log('mod--',OldQty);
            
              if(itemTag == 'CP' && OldQty < 50 || itemTag == 'B2B' && OldQty < minQty){
                if(document.getElementById(errorId) != null){
                  document.getElementById(errorId).style.display = "block";
                }else{
                  if(document.getElementById(errorId) != null){
                    document.getElementById(errorId).style.display = "none";
                  }
                }
              }else{
                var qtyId = itemrow.getAttribute('data-qtyerrorID');
                if(itemTag == 'B2B' || itemTag == 'CP'){
                  
                  if(mod == 0){
                    if(document.getElementById(qtyId) != null){
                      document.getElementById(qtyId).style.display = "none";
                    }
                  }else{
                    if(document.getElementById(qtyId) != null){
                      document.getElementById(qtyId).style.display = "block";
                    }
                  }        
                }
              }
            
          }
          featured_slider(); 
        }, 500);
      }else{
        console.log('Cart drawer quantity is not updated.');
      }
    });
  }
}

function custom_addtocart(variantsId,qty) {

  event.preventDefault();
  
  var pbTempId = Number(variantsId);
  var pbTempQTY = Number(qty);

  addItem(pbTempId, pbTempQTY);

  async function addItem(variantId, quantity) {
    const result = await fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
    .then((data) => {
      if(data.status === 200){  
        // window.scrollTo(0, 0);
        // document.querySelector('body').classList.add('open-drawer');
        // document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');
        load_cart();
        featured_slider();
        window.location.href = "/cart";
        
      }else{
        console.log('cart-drawer error');
      }
    });
  }
}

function featured_slider() {
  if(document.querySelector('.cartDrawerSwiper') != null){
    var swiper = new Swiper(".cartDrawerSwiper", {
      draggable: false,
      slidesPerView: "auto",
      spaceBetween: 8,
      noSwiping: true,
      onlyExternal: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
      750: {
        spaceBetween: 22,
        slidesPerView: 3
      }
     }
    });
  }

  equalHeight(true);
  equalVariantHeight(true);
  var docWidth = document.documentElement.clientWidth;   

  var recPro = document.querySelectorAll('.cart-recom-pro .swiper-slide');
  if(recPro.length == 0){
    if(document.querySelector('.cart-recomdend-product-bags') != null){
      document.querySelector('.cart-recomdend-product-bags').style.display = "none";
    }
  }


  if(document.querySelector('.cart-drawer-footer') != null && document.querySelector('.wrapper-cartdrawer__header') != null){
    var elHeight = 0;
    if(document.querySelector('.right-shipping-text-drawer') != null){
      var el = document.querySelector('.right-shipping-text-drawer');
      elHeight += el.offsetHeight;
      elHeight += parseInt(window.getComputedStyle(el).getPropertyValue('margin-top'));
      elHeight += parseInt(window.getComputedStyle(el).getPropertyValue('margin-bottom'));
    }
    
    var footerHeight = document.querySelector('.cart-drawer-footer').clientHeight;
   
    var SideContentHeight = document.querySelector('.wrapper-cartdrawer__header').clientHeight + footerHeight + elHeight;
   
    var finalHeight = window.innerHeight - SideContentHeight;
    if(document.querySelector('.Main-scroll-item-cart') != null){
      document.querySelector('.Main-scroll-item-cart').style.height = finalHeight+"px";
      if(docWidth > 749){
        document.querySelector('.Main-scroll-item-cart').style.paddingBottom = footerHeight+"px";
      }
    }
  }

  if(document.querySelectorAll('.variant__button-input').length > 0){
    var inputElements = document.querySelectorAll('.variant__button-input');
    
    for(i=0;i<inputElements.length;i++){
      inputElements[i].addEventListener('change',variantSelectorsValue);
    }
  }
  
  if(document.querySelectorAll('.SingleOptionSelector--option').length > 0){
    var variantSelectors  = document.querySelectorAll('.SingleOptionSelector--option');
    variantSelectors.forEach((select) => {
      select.addEventListener('change', function() {
        var finalvalue = '';
        var selectVal = this.value;
        var sizeCheckbox = select.closest('.variant_selector_wrapp').querySelector(".variant__button-input[value='"+selectVal+"']");
        sizeCheckbox.checked = true;
        
        var event = new Event('change');
        sizeCheckbox.dispatchEvent(event);
  
      });
    });
  }
  
}


function afterOfferApplyCall() {
  console.log('enginesAfterOfferApply');
  var btnDrawerCheckout = document.querySelectorAll('.cart__checkout-button');
  if(btnDrawerCheckout.length > 0){
    btnDrawerCheckout.forEach(submitButton => {
      var isDisable = submitButton.getAttribute("data-disable");
      //console.log('isDisable--',isDisable);
      if(isDisable === 'true'){
        //console.log('if--')
      }else{
        submitButton.closest('.cart__btn_group').querySelector('.static_checkout_button').style.display = "none";
        submitButton.style.display = "block";
        
        
        if(submitButton.closest('.cart__btn_group').querySelector('.icon-spinner') != null){
          submitButton.closest('.cart__btn_group').querySelector('.icon-spinner').style.display = "none";
        }
        submitButton.disabled = false;
      }
      
    });
  }
}


function enginesAfterOfferSuccessApply(){ 
  console.log('11');
  afterOfferApplyCall()
}
function enginesAfterOfferCartSuccess(){ 
  console.log('22');
  afterOfferApplyCall()
}





